export const COOKIE_KEY = '__form_api_session_key'
